import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface LoginPayload {
  email: string;
  password: string;
}

export interface LoginTokenData {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
}

export interface LoginValidationErrorItem {
  field: string;
  message: string;
  type?: string;
  ctx?: { reason?: string };
}

export interface LoginValidationErrorData {
  errors?: LoginValidationErrorItem[];
  fields?: Record<string, string[]>;
}

export type LoginResponseData = LoginTokenData | LoginValidationErrorData | null;

export interface LoginApiResponse {
  status: boolean;
  message: string;
  data: LoginResponseData;
}

export function isLoginTokenData(data: LoginResponseData): data is LoginTokenData {
  return !!data && 'accessToken' in data && typeof (data as LoginTokenData).accessToken === 'string';
}

export interface LogoutApiResponse {
  status: boolean;
  message: string;
  data: Record<string, never>;
}

@Injectable({
  providedIn: 'root',
})
export class Auth {
  private http = inject(HttpClient);

  login(email: string, password: string): Observable<LoginApiResponse> {
    const url = `${environment.apiBaseUrl}/v1/auth/login`;
    return this.http.post<LoginApiResponse>(url, { email, password } satisfies LoginPayload);
  }

  refresh(refreshToken: string): Observable<LoginApiResponse> {
    const url = `${environment.apiBaseUrl}/v1/auth/refresh`;
    return this.http.post<LoginApiResponse>(url, { refreshToken });
  }

  logout(): Observable<LogoutApiResponse> {
    const url = `${environment.apiBaseUrl}/v1/auth/logout`;
    return this.http.post<LogoutApiResponse>(url, {});
  }
}
